import React from 'react';
import { string } from 'prop-types';

import { Placeholder } from '@thd-olt-component-react/core-ui';

export const PromotionProductsLoader = ({ experienceTag }) => {
  const numRows = {
    BOGO: 5,
    MSBONLINE: 6,
    BMSM: 5,
  };

  return (
    <>
      { new Array(numRows[experienceTag]).fill('').map((value, i) => (
        <Placeholder type="text" key={`row-${i}`} />
      ))}
    </>
  );
};

PromotionProductsLoader.displayName = 'PromotionProductsLoader';

PromotionProductsLoader.propTypes = {
  /**
   * the conditional promotion experienceTag.
   */
  experienceTag: string.isRequired,
};
